import Vue from 'vue'
import panZoom from 'vue-panzoom'

Vue.use(panZoom)
